module.exports = __webpack_public_path__ + "img/step-1-key.2ea76dcf.svg";